export const GET_QUIZ_QUESTIONS = "GET_QUIZ_QUESTIONS"
export const SET_CURRENT_SECTION = "SET_CURRENT_SECTION"
export const SET_CURRENT_QUESTION = "SET_CURRENT_QUESTION"
export const SET_QUESTION_ANSWER = "SET_QUESTION_ANSWER"
export const SET_TIME_TAKEN = "SET_TIME_TAKEN" 